import { createContext, useContext } from 'react';
import { TOUR_STEPS } from 'views/App/OnBoarding/OnBoardingTour';
import {emptyFunction} from 'utils';

interface MenuContextType {
  getMenuSelectedClassNames: (step?: TOUR_STEPS) => string;
  onMenuItemClick: Function;
  shouldShowMenu: (step?: number) => boolean;
}

const initialState = {
  getMenuSelectedClassNames: () => '',
  onMenuItemClick: emptyFunction,
  shouldShowMenu: () => false,
};

export const MenuContext = createContext<MenuContextType>(initialState);

const { Provider } = MenuContext;

interface MenuProviderProps {
  children: React.ReactNode;
  getMenuSelectedClassNames: (step?: TOUR_STEPS) => string;
  onMenuItemClick?: Function;
  shouldShowMenu: (step?: number) => boolean;
}

export const MenuProvider = ({
  children,
  getMenuSelectedClassNames,
  onMenuItemClick,
  shouldShowMenu,
}: MenuProviderProps): JSX.Element => {
  return (
    <Provider
      value={{ getMenuSelectedClassNames, onMenuItemClick, shouldShowMenu }}
    >
      {children}
    </Provider>
  );
};

export const useMenuContext = () => useContext(MenuContext);

export default useMenuContext;